import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/maryborough")({
  beforeLoad: () => {
    throw redirect({ href: "/conveyancing/hervey-bay", statusCode: 301 });
  },
});
